import RouteTemplate from 'ember-route-template'
import { ResetScroll } from 'teacher-ui-client/modifiers/reset-scroll'

export default RouteTemplate<unknown>(
  <template>
    <div class="w-full" {{ResetScroll onSetup=true onRouterChange=true}}>
      {{outlet}}
    </div>
  </template>,
)
